import { render } from "./AppSinglewithId.vue?vue&type=template&id=97433878&scoped=true"
import script from "./AppSinglewithId.vue?vue&type=script&lang=js"
export * from "./AppSinglewithId.vue?vue&type=script&lang=js"

import "./AppSinglewithId.vue?vue&type=style&index=0&id=97433878&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97433878"]])

export default __exports__